import { cx } from "../../lib/cx.js";
/* empty css                */
import { jsx } from "react/jsx-runtime";
//#region src/components/FooterLinks/FooterLinks.tsx
/** A centred row of small links, such as Help, Privacy and Terms. */
function FooterLinks({ links, className, "aria-label": ariaLabel = "Footer", ...rest }) {
	const visible = links.filter((link) => link.href || link.onClick);
	if (visible.length === 0) return null;
	return /* @__PURE__ */ jsx("nav", {
		className: cx("ds-footer-links", className),
		"aria-label": ariaLabel,
		...rest,
		children: /* @__PURE__ */ jsx("ul", {
			className: "ds-footer-links__list",
			children: visible.map(({ label, href, onClick, as, id }, index) => {
				const Element = as ?? (href ? "a" : "button");
				return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Element, {
					className: "ds-footer-links__link",
					onClick,
					...href ? { href } : { type: Element === "button" ? "button" : void 0 },
					children: label
				}) }, id ?? href ?? index);
			})
		})
	});
}
//#endregion
export { FooterLinks };

//# sourceMappingURL=FooterLinks.js.map